import script from "./CRM10_023RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM10_023RPT.vue?vue&type=script&setup=true&lang=js"

import "./CRM10_023RPT.vue?vue&type=style&index=0&id=6ff53499&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff53499"]])

export default __exports__